import { Typography } from 'antd';

export type NoticeTypeRendererProps = {
  name: string;
  type?: 'name-only' | 'name-highlighted';
};

export const NoticeTypeRenderer = ({ name, type = 'name-only' }: NoticeTypeRendererProps) => {
  const parts = name.split('.');

  if (parts.length !== 3) return name;

  if (type === 'name-only') {
    return parts[2];
  }

  return (
    <>
      <Typography.Text type="secondary">
        {parts[0]}.{parts[1]}.
      </Typography.Text>
      <strong>{parts[2]}</strong>
    </>
  );
};
